<template>
  <div class="absolute inset-y-0 left-0 pt-6 pl-3">

    <!--Boton crear-->
    <div class="group flex items-center cursor-pointer mt-2" @click="showNoticeModal = true, showControlMap = false">
      <div
        v-bind:class="showNoticeModal ? 'bg-red-500 group-hover:bg-danger-color' : 'bg-tertiary-color group-hover:bg-primary-color-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
      <svg aria-hidden="true" focusable="false" data-icon="file-alt" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg>
      </div>
      <div
        v-bind:class="showNoticeModal ? 'bg-danger-color' : 'bg-primary-color-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Nuevo</div>
    </div>
    <notice-modal 
      :showing="showNoticeModal" 
      :geometries="geometries" 
      @close="showNoticeModal = false"
      @createNew = "createNew()">
    </notice-modal>
    <!--/Boton crear-->

    <!--/Boton guardar-->
    <div class="group flex items-center cursor-pointer mt-2" @click="showSave()">
      <div
        v-bind:class="showProjectModal ? 'bg-red-500 group-hover:bg-danger-color' : 'bg-tertiary-color group-hover:bg-primary-color-dark'"
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
      <svg aria-hidden="true" focusable="false" data-icon="save" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"></path></svg>
      <!-- <svg aria-hidden="true" focusable="false" data-icon="file-alt" class="h-6 w-6 fill-current text-gray-100" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"></path></svg> -->
      </div>
      <div
        v-bind:class="showProjectModal ? 'bg-danger-color' : 'bg-primary-color-dark'"
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >Guardar</div>
    </div>
<!--     <project-modal 
      :showing="showProjectModal" 
      :geometries="geometries"
      @close="showProjectModal = false"
      @saved="savedSuccesfully()"
    ></project-modal> -->
    <!--/Boton guardar-->



    <!--Boton nuevo levantamiento-->
  <!--   <div
      class="group flex items-center cursor-pointer"
      @click="showSelectPoint"
    >
      <div
        v-bind:class="
          showSelectHelper
            ? 'bg-red-500 group-hover:bg-danger-color'
            : 'bg-primary-color group-hover:bg-primary-color-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          viewBox="0 0 24 24"
          class="h-6 w-6 fill-current text-gray-100"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <g>
              <rect height="4" width="4" x="10" y="4" />
              <rect height="4" width="4" x="4" y="16" />
              <rect height="4" width="4" x="4" y="10" />
              <rect height="4" width="4" x="4" y="4" />
              <rect height="4" width="4" x="16" y="4" />
              <polygon
                points="11,17.86 11,20 13.1,20 19.08,14.03 16.96,11.91"
              />
              <polygon points="14,12.03 14,10 10,10 10,14 12.03,14" />
              <path
                d="M20.85,11.56l-1.41-1.41c-0.2-0.2-0.51-0.2-0.71,0l-1.06,1.06l2.12,2.12l1.06-1.06C21.05,12.07,21.05,11.76,20.85,11.56z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div
        v-bind:class="
          showSelectHelper ? 'bg-danger-color' : 'bg-primary-color-dark'
        "
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Nuevo levantamiento
      </div>
    </div> -->
    <!--/ Boton nuevo levantamiento-->


    <!-- Boton tipo de mapa-->
    <div
      class="group flex items-center cursor-pointer mt-2"
      @click="showControlMap = !showControlMap"
    >
      <div
        v-bind:class="
          showControlMap
            ? 'bg-red-500 group-hover:bg-danger-color'
            : 'bg-tertiary-color group-hover:bg-primary-color-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current text-gray-100"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
          />
        </svg>
      </div>
      <div
        v-bind:class="
          showControlMap ? 'bg-danger-color' : 'bg-primary-color-dark'
        "
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Tipo de mapa
      </div>
    </div>
    <control-map
      :showing="showControlMap"
      @click="changeMapLayer"
    ></control-map>
    <!--/ Boton tipo de mapa-->
    
  </div>


  
</template>
<script>
import noticeModal from "./NoticeModal";
import controlMap from "./ControlMap";

export default {
  name: "Button",
  data() {
    return {
      showNoticeModal: false,
      showProjectModal: false,
      showSelectHelper: false,
      showControlMap: false,
    };
  },
  mounted() {},
  components: {
    noticeModal,
    controlMap,
  },
  methods: {
    changeMapLayer(map) {
      this.$emit("click", map);
    },
    showSelectPoint() {
      this.$emit("showPointSelector");
    },

    createNew(map) {
      this.$emit("createNew");
    },

    showSave(){
      console.log("showsave")
      this.$emit("muestraLevantamientoModal");
      //showControlMap = false
    }

  },
  props: {
    geometries: {
       required: true
     }    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
